/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkEmployeeGroupWebsiteDto } from '../models/work-employee-group-website-dto';
import { WorkEmployeeWebsiteDto } from '../models/work-employee-website-dto';

@Injectable({ providedIn: 'root' })
export class WorkWebsiteEmployeesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `websiteEmployeesV2ControllerGetEmployeesAll()` */
  static readonly WebsiteEmployeesV2ControllerGetEmployeesAllPath = '/v2/website/employees/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteEmployeesV2ControllerGetEmployeesAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEmployeeWebsiteDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteEmployeesV2Service.WebsiteEmployeesV2ControllerGetEmployeesAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEmployeeWebsiteDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteEmployeesV2ControllerGetEmployeesAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkEmployeeWebsiteDto>> {
    return this.websiteEmployeesV2ControllerGetEmployeesAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEmployeeWebsiteDto>>): Array<WorkEmployeeWebsiteDto> => r.body)
    );
  }

  /** Path part for operation `websiteEmployeesV2ControllerGetEmployeesContactAdministration()` */
  static readonly WebsiteEmployeesV2ControllerGetEmployeesContactAdministrationPath = '/v2/website/employees/contact-administration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteEmployeesV2ControllerGetEmployeesContactAdministration()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesContactAdministration$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEmployeeWebsiteDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteEmployeesV2Service.WebsiteEmployeesV2ControllerGetEmployeesContactAdministrationPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEmployeeWebsiteDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteEmployeesV2ControllerGetEmployeesContactAdministration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesContactAdministration(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkEmployeeWebsiteDto>> {
    return this.websiteEmployeesV2ControllerGetEmployeesContactAdministration$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEmployeeWebsiteDto>>): Array<WorkEmployeeWebsiteDto> => r.body)
    );
  }

  /** Path part for operation `websiteEmployeesV2ControllerGetEmployeesSolar()` */
  static readonly WebsiteEmployeesV2ControllerGetEmployeesSolarPath = '/v2/website/employees/solar';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteEmployeesV2ControllerGetEmployeesSolar()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesSolar$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteEmployeesV2Service.WebsiteEmployeesV2ControllerGetEmployeesSolarPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteEmployeesV2ControllerGetEmployeesSolar$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesSolar(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkEmployeeGroupWebsiteDto>> {
    return this.websiteEmployeesV2ControllerGetEmployeesSolar$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>): Array<WorkEmployeeGroupWebsiteDto> => r.body)
    );
  }

  /** Path part for operation `websiteEmployeesV2ControllerGetRandomEmployeeForTag()` */
  static readonly WebsiteEmployeesV2ControllerGetRandomEmployeeForTagPath = '/v2/website/employees/random/{tag}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteEmployeesV2ControllerGetRandomEmployeeForTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetRandomEmployeeForTag$Response(
    params: {
      tag: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEmployeeWebsiteDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteEmployeesV2Service.WebsiteEmployeesV2ControllerGetRandomEmployeeForTagPath, 'get');
    if (params) {
      rb.path('tag', params.tag, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEmployeeWebsiteDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteEmployeesV2ControllerGetRandomEmployeeForTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetRandomEmployeeForTag(
    params: {
      tag: string;
    },
    context?: HttpContext
  ): Observable<WorkEmployeeWebsiteDto> {
    return this.websiteEmployeesV2ControllerGetRandomEmployeeForTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEmployeeWebsiteDto>): WorkEmployeeWebsiteDto => r.body)
    );
  }

  /** Path part for operation `websiteEmployeesV2ControllerGetEmployeesDach()` */
  static readonly WebsiteEmployeesV2ControllerGetEmployeesDachPath = '/v2/website/employees/dach';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteEmployeesV2ControllerGetEmployeesDach()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesDach$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteEmployeesV2Service.WebsiteEmployeesV2ControllerGetEmployeesDachPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteEmployeesV2ControllerGetEmployeesDach$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesDach(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkEmployeeGroupWebsiteDto>> {
    return this.websiteEmployeesV2ControllerGetEmployeesDach$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>): Array<WorkEmployeeGroupWebsiteDto> => r.body)
    );
  }

  /** Path part for operation `websiteEmployeesV2ControllerGetEmployeesWaermepumpen()` */
  static readonly WebsiteEmployeesV2ControllerGetEmployeesWaermepumpenPath = '/v2/website/employees/waermepumpen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteEmployeesV2ControllerGetEmployeesWaermepumpen()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesWaermepumpen$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteEmployeesV2Service.WebsiteEmployeesV2ControllerGetEmployeesWaermepumpenPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteEmployeesV2ControllerGetEmployeesWaermepumpen$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesWaermepumpen(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkEmployeeGroupWebsiteDto>> {
    return this.websiteEmployeesV2ControllerGetEmployeesWaermepumpen$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>): Array<WorkEmployeeGroupWebsiteDto> => r.body)
    );
  }

  /** Path part for operation `websiteEmployeesV2ControllerGetEmployeesZentraleDienste()` */
  static readonly WebsiteEmployeesV2ControllerGetEmployeesZentraleDienstePath = '/v2/website/employees/zentrale-dienste';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteEmployeesV2ControllerGetEmployeesZentraleDienste()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesZentraleDienste$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteEmployeesV2Service.WebsiteEmployeesV2ControllerGetEmployeesZentraleDienstePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteEmployeesV2ControllerGetEmployeesZentraleDienste$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteEmployeesV2ControllerGetEmployeesZentraleDienste(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkEmployeeGroupWebsiteDto>> {
    return this.websiteEmployeesV2ControllerGetEmployeesZentraleDienste$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEmployeeGroupWebsiteDto>>): Array<WorkEmployeeGroupWebsiteDto> => r.body)
    );
  }

}
